import { Select } from 'antd';
import './index.css';
import { useQuizFormContext } from '../../hooks/quiz-form-context';

const Multiselect = ({
  questionValueOptions,
  name,
  allInputOnchageHandler,
  indexKey,
  title
}) => {
  const {
    formValues,
    getInputValues,
  } = useQuizFormContext();
  const options = questionValueOptions.map(questionValueOption => {
    return { label: questionValueOption.fields.name, value: questionValueOption.fields.name }
  })
  function findMatchingObjects(arr1, arr2) {
    const matchedObjects = [];

    // Iterate over arr2 to find matching objects
    for (const obj of arr2) {
      if (arr1.includes(obj.fields.value)) {
        matchedObjects.push({ id: obj.sys.id, value: obj.fields.value }); // Collect matching objects
      }
    }

    return matchedObjects; // Return array of matched objects
  }
  const handleChange = (value) => {
    const result = findMatchingObjects(value, questionValueOptions);
    allInputOnchageHandler(indexKey, title, name, result);
  };
  const hazardsFromFullList = getInputValues('93', formValues)?.value || []
  const defaultValues = hazardsFromFullList.map(hazard => hazard.value)
  return (
    <>
      <div className="text-heading-container">
        <Select
          mode="multiple"
          allowClear
          style={{
            width: '50%',
          }}
          defaultValue={defaultValues}
          placeholder="Please select"
          onChange={handleChange}
          options={options}
        />
      </div>
    </>
  );
};

export default Multiselect;
